import { render, staticRenderFns } from "./kpiResultTable.vue?vue&type=template&id=db80d098&"
import script from "./kpiResultTable.vue?vue&type=script&lang=js&"
export * from "./kpiResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports